import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=6bef4986&scoped=true&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.scss?vue&type=style&index=0&id=6bef4986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef4986",
  null
  
)

export default component.exports